import React, { createContext, useContext, useState } from 'react';

// Create the context
const DataContext = createContext();

// Provider component
export const DataProvider = ({ children }) => {

    const [dataState, setDataState] = useState({
        level: null,
    });

    const setEachDataState = (key, value) => {
        setDataState(prev => ({
            ...prev,
            [key]: value,
        }));
    };

    return (
        <DataContext.Provider value={{ dataState, setDataState, setEachDataState }}>
            {children}
        </DataContext.Provider>
    );
};

// Hook to use the context
export const useData = () => useContext(DataContext);
